import {
  Input,
  InputProps,
  styled,
} from '@mui/material'

export const StyledInput = styled((props: InputProps) => (
  <Input {...props} />
))(() => ({
  '&': {
    padding: '11px 12px',
    borderRadius: '8px',
    border: '1px solid #3A3F5D',
    backgroundColor: '#2A3748',
    fontSize: '12px',
    lineHeight: '18px',
    color: '#E7E8EB',
    transition: 'border 0.2s ease',
  },
  '& .MuiInput-input': {
    padding: '0 12px 0 0',
    fontSize: '14px',
    lineHeight: '20px',
  },
  '&.Mui-focused': {
    borderColor: '#fff',
  },
  '&.Mui-error': {
    borderColor: '#f44336',
  },
}))
